import React from 'react';
import {Redirect, Route} from 'react-router-dom';

import {isAdministrator} from '../helpers/auth.helper';

export const PrivateRoute = ({component: Component, ...rest}) => (
    <Route {...rest} render={props => (
        localStorage.getItem('token')
            ?
            (rest.path === '/dashboard' || isAdministrator() ? <Component {...props} /> : <Redirect to={{pathname: '/dashboard', state: {from: props.location}}}/>)
            :
            <Redirect to={{pathname: '/login', state: {from: props.location}}}/>
    )}/>
);


// WEBPACK FOOTER //
// src/components/PrivateRoute.js